import React from "react";
import { Box, Flex } from "theme-ui";
import { colors, typography, Button } from "@greythr/shared-components";

const ErrorComponent = ({ resetForm, regionCode }) => {
  return (
    <Flex className="glass300" sx={mainContainerStyles}>
      <Box>
        <Box
          sx={{
            ...typography.h3,
            mb: "1.5rem",
            mt: ["2rem", "2rem", "3rem", "4rem"],
          }}
        >
          Something went wrong.
        </Box>
        <Box sx={errorFormStyles}>
          Sorry for the trouble. Please try filling the form again.
        </Box>
        <Box
          sx={{
            width: "100%",
            maxWidth: ["16.813rem", "16.813rem", "18.75rem", "18.75rem"],
            margin: "auto",
          }}
        >
          <video autoPlay loop muted playsInline preload="auto" width="100%">
            <source
              src="https://www.datocms-assets.com/40521/1726654366-exclamation.mp4"
              type="video/mp4"
            />
          </video>
        </Box>
      </Box>
      <Box sx={{ my: ["2rem", "2rem", "3rem", "4rem"] }}>
        <Button
          id={`upsell_go_back_${regionCode.toLowerCase()}_btn`}
          variant="filled"
          size="large"
          onClick={resetForm}
        >
          Go Back
        </Button>
      </Box>
    </Flex>
  );
};

const { mainContainerStyles, errorFormStyles } = {
  mainContainerStyles: {
    flexDirection: "column",
    justifyContent: "space-between",
    px: ["0.75rem", "0.75rem", "1.969rem", "1.969rem"],
    minHeight: ["34.188rem", "34.188rem", "40.125rem", "36.75rem"],
    margin: "auto",
    borderRadius: "1.25rem",
    border: `1.14px solid ${colors.neutral200}`,
    maxWidth: "72rem",
    textAlign: "center",
    mx: ["1rem", "1rem", "2rem", "auto"],
  },
  errorFormStyles: {
    ...typography.textLg500,
    color: colors.neutral900,
    mb: ["2rem", "2rem", "3rem", "4rem"],
    "@media (max-width: 599px)": {
      ...typography.textMd500,
    },
  },
};

export default ErrorComponent;
